window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.notifikacijeRepo = function () {
    var url = 'api/notifikacije';

    var list = function (neprocitane = true, jeStory = false) {
        return fetch(url + casino.repos.base.serializeGetParams({
            neprocitane: neprocitane,
            jeStory: jeStory
        }), {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    var remove = function (notifikacija) {

        var n = {
            ...notifikacija
        };

        n.popHtml = null;
        n.inboxHtml = null;
        n.ctAs = null;
        n.pushSlika = null;

        return fetch(url, {
            method: 'DELETE',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify(n)
        })
            .then(casino.repos.base.checkResponse)
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        remove: remove,
        list: list
    }

}();